import React from 'react';

export default function FullFixLogo({ height = 40, light = false }) {
  const textColor = light ? '#ffffff' : '#1a1a1a';
  const scale = height / 40;
  const width = Math.round(230 * scale);

  return (
    <svg width={width} height={height} viewBox="0 0 230 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      {/* Box icon */}
      <g transform="translate(0, 2)">
        {/* Box body */}
        <path d="M4 14L18 6L32 14V28L18 36L4 28V14Z" fill="#E8520E" />
        {/* Box top flap left */}
        <path d="M4 14L18 22L18 6L4 14Z" fill="#F47B3E" />
        {/* Box top flap right */}
        <path d="M32 14L18 22L18 6L32 14Z" fill="#D14600" />
        {/* Box front shadow */}
        <path d="M4 14L18 22V36L4 28V14Z" fill="#E8520E" />
        <path d="M32 14L18 22V36L32 28V14Z" fill="#C24000" />
      </g>
      {/* FULL text */}
      <text x="42" y="29" fontFamily="'Inter', 'Segoe UI', system-ui, -apple-system, sans-serif" fontSize="26" fontWeight="900" letterSpacing="-0.5" fill={textColor}>
        FULL
      </text>
      {/* - */}
      <text x="111" y="29" fontFamily="'Inter', 'Segoe UI', system-ui, -apple-system, sans-serif" fontSize="26" fontWeight="900" fill={textColor} opacity="0.3">
        -
      </text>
      {/* FIX text */}
      <text x="130" y="29" fontFamily="'Inter', 'Segoe UI', system-ui, -apple-system, sans-serif" fontSize="26" fontWeight="900" letterSpacing="-0.5" fill="#E8520E">
        FIX
      </text>
    </svg>
  );
}
